import { tx } from "../i18n";

/**
 * Recurring-frequency helpers shared by Receivables, Payments, and
 * Movements pages. The backend's `_add_period` in `services/automation.py`
 * uses these exact day counts — keep this table in sync.
 */
const FREQ_DAYS = {
  weekly: 7,
  biweekly: 14,
  monthly: 30,
  quarterly: 91,
  yearly: 365,
};

/**
 * Returns the next ISO date (YYYY-MM-DD) after `baseIso` given the
 * recurring `frequency`. Returns null when inputs are invalid OR the next
 * date would land past `endIso` (exclusive end).
 */
export function nextRecurringDate(baseIso, frequency, endIso = null) {
  if (!baseIso || !frequency || !(frequency in FREQ_DAYS)) return null;
  const base = new Date(baseIso);
  if (Number.isNaN(base.getTime())) return null;
  const next = new Date(base.getTime() + FREQ_DAYS[frequency] * 86400000);
  if (endIso) {
    const end = new Date(endIso);
    if (!Number.isNaN(end.getTime()) && next > end) return null;
  }
  return next;
}

/**
 * Format a Date for inline preview using the user's locale.
 * Returns null if the date is missing.
 */
export function formatNextDate(d, lang = "en") {
  if (!d) return null;
  try {
    return d.toLocaleDateString(tx(lang, undefined, "es-CO", "pt-BR"), {
      day: "numeric",
      month: "short",
      year: "numeric",
    });
  } catch {
    return d.toISOString().slice(0, 10);
  }
}
